import React, { Component } from "react";
import UserRequestCardList from "./components/user_request_card_list";
import { Api } from "../utils/api";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button/Button";
import { observer } from "mobx-react";
import moment from "moment";

const UserRequestsListing = observer(
  class UserRequestsListing extends Component {
    state = {
      day: undefined,
      userRequests: [],
    };

    constructor() {
      super();
      this.api = new Api();
    }

    componentDidMount() {
      this.search();
    }

    search(day = new Date()) {
      const start = moment(day);
      const end = moment(day).add(1, "day");
      this.api
        .get("/user_requests", {
          request_since: start.format("YYYY-MM-DD"),
          request_until: end.format("YYYY-MM-DD"),
          no_pagination: true,
        })
        .then((data) => {
          console.log(data);
          return data;
        })
        .then(({ data: userRequests }) => {
          this.setState({ userRequests, day });
        });
    }

    toDayBefore = () => {
      const { day = new Date() } = this.state;
      const newDay = moment(day).subtract(1, "day");
      this.search(newDay);
    };

    toDayAfter = () => {
      const { day = new Date() } = this.state;
      const newDay = moment(day).add(1, "day");
      this.search(newDay);
    };

    toToday = () => {
      const { day = new Date() } = this.state;
      const newDay = moment(day).add(1, "day");
      this.search(newDay);
    };

    render() {
      const { userRequests, day = new Date() } = this.state;
      return (
        <>
          <Grid container justify="center">
            <div>{moment(day).format("YYYY-MM-DD")}</div>
          </Grid>
          <Grid container justify="space-around">
            <Button onClick={this.toDayBefore}>Dia Anterior</Button>
            <Button onClick={this.toToday}>Hoje</Button>
            <Button onClick={this.toDayAfter}>Dia Seguinte</Button>
          </Grid>
          <UserRequestCardList requests={userRequests} />
          <Grid container justify="space-around">
            <Button onClick={this.toDayBefore}>Dia Anterior</Button>
            <Button onClick={this.toToday}>Hoje</Button>
            <Button onClick={this.toDayAfter}>Dia Seguinte</Button>
          </Grid>
        </>
      );
    }
  }
);

export default UserRequestsListing;
